module.exports = __webpack_public_path__ + "static/LibreFranklin-BoldItalic-266d36cc1a0aeece00be49806c30cfb2.ttf";